/**
 * This overlay keeps retained insight data readable while a background refetch is in progress.
 */
import React from 'react';
import Loader from '@amzn/meridian/loader';

const refreshLoaderStyle: React.CSSProperties = {
  alignItems: 'center',
  background: 'rgba(255, 255, 255, 0.55)',
  display: 'flex',
  inset: 0,
  justifyContent: 'center',
  pointerEvents: 'none',
  position: 'absolute',
  zIndex: 1,
};

interface RefreshLoaderProps {
  readonly testId: string;
}

export const RefreshLoader: React.FC<RefreshLoaderProps> = ({ testId }) => (
  <div data-testid={testId} style={refreshLoaderStyle}>
    <Loader size="small" />
  </div>
);
